import { formatToolName } from '../utils/conversationUtils';

type ToolUseIndicatorProps = {
  toolName: string;
  styles: Record<string, string>;
};

export function ToolUseIndicator({ toolName, styles }: ToolUseIndicatorProps) {
  return (
    <div className={styles.toolUseIndicator}>
      <div className={styles.spinner} />
      <span>Using {formatToolName(toolName)}...</span>
    </div>
  );
}
